/**
 * react-big-calendar reports a selection end that is exclusive.
 * A drag that stops on 11 October arrives as 12 October 00:00.
 * The last hovered day is the one the user actually selected, closed at 23:59.
 */
export function lastHoveredDayEnd(end: Date): Date {
  const isMidnight =
    end.getHours() === 0 &&
    end.getMinutes() === 0 &&
    end.getSeconds() === 0 &&
    end.getMilliseconds() === 0;

  if (!isMidnight) return end;

  const inclusive = new Date(end);
  inclusive.setDate(inclusive.getDate() - 1);
  inclusive.setHours(23, 59, 0, 0);
  return inclusive;
}
